import { Filter } from '../constants/filters/filterTypes'

export const isActiveFilter = (filters: Filter[]) => {
  if (filters.length) {
    return filters.filter(({ isActive }) => isActive === true)
  }
}
